import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { showCreateEditModal, showCredentialDetail } from 'store/Credentials/actions';
import { Edit } from '../../styled';
import IconButton from 'Common/Components/IconButton';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectCredentialsSelected } from 'store/Credentials/selectors';

const EditButton = ({ rowInfo }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showWarning, setShowWarning] = useState(false);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const credentialInVuln = get(rowInfo, 'original', {});
  const id = get(rowInfo, 'original.id', '');
  const message = intl.formatMessage(
    { id: 'modalWarning.selectOnlyOne' },
    { entity: 'Credential' }
  );
  const edit = intl.formatMessage({
    id: 'credentials.modalCreateEdit.editTitle'
  });
  const disabled = credentialsSelected.length > 1;

  const handleClick = () => {
    if (credentialsSelected.length === 1) dispatch(showCredentialDetail(true, get(credentialsSelected, '[0].value.workspace_name'), get(credentialsSelected, '[0].value.id')));
    else if (id) dispatch(showCreateEditModal(true, credentialInVuln));
    else setShowWarning(true);
  };

  const onClose = () => setShowWarning(false);
  return (
    <>
      <IconButton icon={ <Edit /> } title={ edit } onClick={ handleClick } disabled={ disabled } />
      {showWarning && (
        <ModalWarning
          onCloseCallback={ onClose }
          title="Edit Credential"
          description={ message }
        />
      )}
    </>
  );
};

export default EditButton;
